import Away from "./Away";

export default Away;
